export function baseUrl() {
    if (window.location.href.includes('localhost')) {
        return `https://localhost:5001/api/`;
    }
    else {
        return `https://api.elearning.${window.location.host.replace("www.", "")}/api/`
    }
}
